import { NotifyHelper } from "../../../helpers/toast";
import { eTongHopNamActionsObj } from "../../action-types/tong-hop-diem/ITongHopNamActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const tongHopNamActions = {
    ...generateActions(eTongHopNamActionsObj, "TONG_HOP_NAM"),
    ...generateActionForKey(eTongHopNamActionsObj, "TONG_HOP_NAM", "LOAD_ERROR", (m) => {
        NotifyHelper.Error(m);
    })
}